/**
 * Upload limits aligned with backend MAX_UPLOAD_SIZE_MB (default 100) and nginx
 * client_max_body_size on lecoffreio proxy vhosts (100m = total multipart body per request).
 */

/** Per-file limit (bytes) — matches mimeTypesConfig and multer fileSize. */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 104_857_600;

/**
 * Max total size for one batch send (all files in a single multipart request).
 * Matches nginx `client_max_body_size 100m` on test/pprod/prod.lecoffreio.4nkweb.com (proxy 192.168.1.100).
 */
export const MAX_SEND_BATCH_TOTAL_BYTES = 104_857_600;

/** Max files per send — matches DocumentsNotaryBatchMulterHelper `.array("files", 20)`. */
export const MAX_SEND_BATCH_FILE_COUNT = 20;

export const MAX_SEND_BATCH_TOTAL_MB = MAX_SEND_BATCH_TOTAL_BYTES / (1024 * 1024);

export const TOO_MANY_BATCH_FILES_USER_MESSAGE = `Vous ne pouvez pas envoyer plus de ${MAX_SEND_BATCH_FILE_COUNT} fichiers en une seule fois. Retirez des fichiers ou effectuez plusieurs envois.`;
